import clsx from "clsx";
import { ReactNode } from "react";
import css from "./LinkButton.module.css";
import { Link } from "react-router";

export function LinkButton(props: {
  children: ReactNode;
  color?: "green" | "yellow" | "gray" | "red";
  to: string;
}) {
  const color = props.color ?? "gray";

  return (
    <Link className={clsx(css.button, css[color])} to={props.to}>
      <span className={css.wrapper}>{props.children}</span>
    </Link>
  );
}
